import { render, staticRenderFns } from "./TaxonHeader.vue?vue&type=template&id=49d96738"
import script from "./TaxonHeader.vue?vue&type=script&lang=js"
export * from "./TaxonHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports